var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleDarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1297",
    "data-name": "Grupo 1297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.412,
    height: 29.404,
    viewBox: "0 0 29.412 29.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_568",
    "data-name": "Rect\\xE1ngulo 568",
    width: 29.412,
    height: 29.404,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1296",
    "data-name": "Grupo 1296",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "M14.725,0A14.766,14.766,0,0,0,0,14.59,14.791,14.791,0,0,0,14.662,29.4a14.794,14.794,0,0,0,14.75-14.677A14.766,14.766,0,0,0,14.725,0",
    transform: "translate(0 0.001)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "M14.725,0A14.766,14.766,0,0,1,29.412,14.726,14.794,14.794,0,0,1,14.662,29.4,14.791,14.791,0,0,1,0,14.59,14.766,14.766,0,0,1,14.725,0m7.783,10.594a1.4,1.4,0,0,0-.842-1.059.993.993,0,0,0-1.115.228,4,4,0,0,0-.453.407q-3.207,3.194-6.406,6.4c-.293.3-.468.289-.753-.007-.846-.878-1.716-1.733-2.587-2.586A1.234,1.234,0,0,0,8.83,13.62,1.161,1.161,0,0,0,8.546,15.6q1.962,1.985,3.953,3.94a1.1,1.1,0,0,0,1.694-.025q3.962-3.931,7.906-7.88a1.266,1.266,0,0,0,.409-1.045",
    transform: "translate(0 0.001)",
    fill: "#1a78f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    d: "M100.789,101.74a1.266,1.266,0,0,1-.409,1.045q-3.948,3.945-7.906,7.88a1.1,1.1,0,0,1-1.694.025q-1.986-1.961-3.953-3.94a1.161,1.161,0,0,1,.283-1.984,1.234,1.234,0,0,1,1.521.352c.871.853,1.742,1.708,2.587,2.586.285.3.46.3.753.007q3.189-3.212,6.406-6.4a4,4,0,0,1,.453-.407.993.993,0,0,1,1.115-.228,1.4,1.4,0,0,1,.842,1.059",
    transform: "translate(-78.282 -91.146)",
    fill: "#fefefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleDarker);
export default __webpack_public_path__ + "static/media/check_circle_darker.c3d27c6750937dde0a57580aa5eabb33.svg";
export { ForwardRef as ReactComponent };